import { motion } from 'framer-motion'
import { CalendarPlus, Receipt, UserCheck, UserPlus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { COMMAND_QUICK_ACTIONS } from '@/lib/commandRoutes'

const ICONS = {
  'New booking': CalendarPlus,
  POS: Receipt,
  'Check in': UserCheck,
  'New guest': UserPlus,
}

export function QuickActionsDock() {
  const navigate = useNavigate()

  return (
    <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 -translate-x-1/2">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="pointer-events-auto glass-luxury flex items-center gap-1 rounded-2xl p-1.5 shadow-dock"
      >
        {COMMAND_QUICK_ACTIONS.map((action, i) => {
          const Icon = ICONS[action.label] ?? CalendarPlus
          return (
            <motion.button
              key={action.label}
              type="button"
              onClick={() => navigate(action.route)}
              whileHover={{ scale: 1.04, y: -1 }}
              whileTap={{ scale: 0.97 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 + i * 0.04 }}
              className="flex items-center gap-2 rounded-xl px-3 py-2 text-[11px] font-semibold transition-colors hover:bg-primary/10 hover:text-primary"
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
              <span className="hidden sm:inline">{action.label}</span>
            </motion.button>
          )
        })}
      </motion.div>
    </div>
  )
}
